import { createApiHooks, httpStatusAsData } from '@apis/next/common';
import {
  ArrivalNotice,
  PatchArrivalNotice,
  PostArrivalNotice,
  PutArrivalNotice,
} from '@models/next/ArrivalNotice';
import { z } from 'zod';

export const arrivalNoticeHooks = createApiHooks('/arrival-notice', [
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        name: 'id',
        type: 'Path',
        schema: z.number(),
      },
    ],
    response: ArrivalNotice,
  },
]);

export const dashboardArrivalNoticeHooks = createApiHooks('/dashboard/arrival-notice', [
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        name: 'id',
        schema: z.number(),
        type: 'Path',
      },
    ],
    response: ArrivalNotice.nullable(),
  },
  {
    method: 'put',
    path: '/:id',
    parameters: [
      {
        name: 'id',
        schema: z.number(),
        type: 'Path',
      },
      {
        name: 'body',
        schema: PutArrivalNotice,
        type: 'Body',
      },
    ],
    response: ArrivalNotice,
  },
  {
    method: 'patch',
    path: '/:id',
    parameters: [
      {
        name: 'id',
        schema: z.number(),
        type: 'Path',
      },
      {
        name: 'body',
        schema: PatchArrivalNotice,
        type: 'Body',
      },
    ],
    response: ArrivalNotice,
  },
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        name: 'body',
        schema: PostArrivalNotice,
        type: 'Body',
      },
    ],
    response: z.unknown(),
  },
]);

dashboardArrivalNoticeHooks.client.use(
  'get',
  '/dashboard/arrival-notice/:id',
  httpStatusAsData(404, null),
);
